import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AutomationmasterService, CommonService } from '@fitness-force/api';
import { AutomationCategory, AutomationEventType } from '@fitness-force/enum';
import {
  AutomationCategoryList,
  AutomationMaster,
  CustomAutomationData,
} from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmEventType, ConfirmationService } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { StyleClassModule } from 'primeng/styleclass';
import { SkeletonModule } from 'primeng/skeleton';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CommmonPipeModule } from '@fitness-force/pipes/common-pipes';

@Component({
  selector: 'fitness-force-select-automation-event-popup',
  templateUrl: './select-automation-event-popup.component.html',
  styleUrls: ['./select-automation-event-popup.component.css'],
  standalone: true,
  imports: [CommonModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    StyleClassModule,
    BadgeModule,
    SkeletonModule,
    TranslateModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    CommmonPipeModule]
})
export class SelectAutomationEventPopupComponent implements OnInit {
  active1: number = 0;
  newLeadCreated: boolean = true;
  automationTriggers: boolean = false;
  modelData: CustomAutomationData = {} as CustomAutomationData;
  automationMasters: AutomationMaster[] = [];
  selectedAutomationCategory: any;
  selectedAutomationEvent: AutomationMaster | null =
    {} as AutomationMaster | null;
  btnLoading: boolean = false;
  loading: boolean = true;
  automationCategoryArray: AutomationCategoryList[] = Object.keys(
    AutomationCategory
  )
    .filter(
      (key: string) =>
        !isNaN(
          Number(AutomationCategory[key as keyof typeof AutomationCategory])
        )
    )
    .map((key: string) => ({
      name: key,
      value: AutomationCategory[key as keyof typeof AutomationCategory],
      count: 0,
      icon: this.getIconByKey(key),
    }));

  search: string = '';
  recentSearchList: string[] = [];
  toggleRecentSearch = false;
  @ViewChild('recentSearch') recentSearch!: ElementRef;
  @ViewChild('searchInput') searchInput!: ElementRef;

  @ViewChildren('category') categories: QueryList<ElementRef> | any;
  @ViewChildren('categorycontainer') itemscontainer:
    | QueryList<ElementRef>
    | any;

  groupedAutomationMasters: any[] = [];

  constructor(
    private commonService: CommonService,
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cd: ChangeDetectorRef,
    private automationService: AutomationmasterService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService
  ) {
    if (this.config.data) {
      this.modelData = this.config.data;
      if (
        this.modelData.automationMaster == null &&
        this.modelData.automationType == null
      ) {
        this.selectedAutomationEvent = null;
      } else {
        this.selectedAutomationEvent = this.modelData.automationMaster;
      }
    } else {
      this.selectedAutomationEvent = null;
    }

    if (localStorage.getItem('automation_search')) {
      this.recentSearchList = JSON.parse(
        localStorage.getItem('automation_search')!
      );
    }
  }

  ngOnInit(): void {
    //this.selectedAutomationCategory = AutomationCategory.Sales;
    this.getAutomationMaster();
  }

  getAutomationMaster() {
    this.loading = true;
    this.automationService.GetAutomationMasters().subscribe({
      next: (response: AutomationMaster[]) => {
        const data =response && response.length > 0 ? response.filter((o:AutomationMaster) => (o.automation_type.toString() !== "Campaign")) : [];
        this.automationMasters = data;

        this.automationCategoryArray.forEach((c) => {
          if (
            this.automationMasters.filter(
              (o) => o.category == c.value || c.name == o.category.toString()
            )!.length > 0
          ) {
            c.count = this.automationMasters.filter(
              (o) => o.category == c.value || c.name == o.category.toString()
            )!.length;
          }
        });

        this.automationMasters.forEach((o) => {
          if (this.automationCategoryArray.find((c) => c.value == o.category)) {
            o.category_name = this.automationCategoryArray.find(
              (c) => c.value == o.category
            )?.name;
          }
        });

        var groupedData = this.automationMasters.reduce(
          (acc: any, curr: AutomationMaster) => {
            const key = curr.category_name;
            if (key) {
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(curr);
            }
            return acc;
          },
          {}
        );

        this.groupedAutomationMasters = Object.entries(groupedData).map(
          ([key, value]) => ({
            category_name: key,
            events: value,
            count: (value as any[]).length
          })
        );
        this.loading = false;
        this.cd.detectChanges();
      },
      error: (error: any) => {
        this.automationMasters = [];
        this.loading = false;
        this.cd.detectChanges();
      },
    });
  }

  SelectAutomationEvent(event: AutomationMaster | null) {
    if (
      this.modelData.automationType != null &&
      this.modelData.automationType != event!.automation_type &&
      this.modelData.actionsConfigured
    ) {
      this.confirmDialog(event);
    } else {
      this.selectedAutomationEvent = event;
      if (event != null) {
        this.modelData.automationType =
          this.selectedAutomationEvent!.automation_type;
        this.modelData.automationMaster = this.selectedAutomationEvent;
      }
      this.cd.detectChanges();
    }
  }

  SelectCategory(category: any) {
    //var category =  AutomationCategory[category.category_name as keyof typeof AutomationCategory];
    this.selectedAutomationCategory = category.category_name;
    this.itemscontainer.forEach((item: ElementRef) => {
      if (category.category_name == item.nativeElement.id) {
        item.nativeElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
    this.cd.detectChanges();
  }

  getCategoryData(category: any) {
    return this.automationCategoryArray.find(
      (c) => c.name == category.category_name
    );
  }

  SaveData() {
    if (this.selectedAutomationEvent != null) {
      this.btnLoading = true;
      this.btnLoading = false;
      this.ref.close(this.modelData);
    } else {
      this.btnLoading = false;
      this.cd.detectChanges();
    }
  }

  getAutomationbyCategory(category: AutomationCategory) {
    if (this.search) {
      return this.automationMasters.filter(
        (s: AutomationMaster) =>
          s.friendly_name != null &&
          s.friendly_name
            .toString()
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    } else {
      return this.automationMasters.filter((o) => o.category == category);
    }
  }

  parseMap(category: any) {
    if (this.search != '') {
      const result = category.events.filter(
        (s: any) =>
          s.friendly_name.toLowerCase().includes(this.search.toLowerCase()) ||
          s.description.toLowerCase().includes(this.search.toLowerCase())
      );
      if (result && result.length > 0) {
        return result;
      } else return [...category.events];
    } else return [...category.events];
  }

  getIconByKey(key: string): string {
    switch (key) {
      case 'Sales':
        return 'fa fa-bar-chart'; // Example icon class for Sales
      case 'Retention':
        return 'fa fa-user-plus'; // Example icon class for Retention
      case 'Backend_Event':
        return 'fa fa-gear'; // Example icon class for Backend_Event
      case 'Billing_Payment':
        return 'fa fa-money-bill'; // Example icon class for Billing_Payment
      case 'Memberships_Subscriptions':
        return 'fa fa-users'; // Example icon class for Memberships_Subscriptions
      case 'Appointments':
        return 'fa fa-calendar'; // Example icon class for Appointments
      case 'Classes':
        return 'fa fa-book'; // Example icon class for Classes
      case 'Freeze':
        return 'fa fa-snowflake'; // Example icon class for Freeze
      default:
        return ''; // Default icon class
    }
  }

  confirmDialog(event: AutomationMaster | null) {
    this.translateService
      .get('AUTOMATION.CREATE.CONIFRM_INFO')
      .subscribe((translations) => {
        this.confirmationService.confirm({
          header: 'Confirmation',
          message: translations,
          icon: 'fa fa-exclamation-triangle',
          accept: () => {
            this.selectedAutomationEvent = event;
            this.modelData.dataChanged = true;
            this.modelData.automationType = event!.automation_type;
            this.modelData.automationMaster = event;
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                this.modelData.dataChanged = false;
                break;
              case ConfirmEventType.CANCEL:
                this.modelData.dataChanged = false;
                break;
            }
          },
        });
      });
  }

  closePopup() {
    this.ref.close(null);
  }

  async SearchAutomation(search: string) {
    this.search = search;
    if (search.length > 2) {
      const results = this.automationMasters.filter(
        (s: AutomationMaster) =>
          s.friendly_name != null &&
          s.friendly_name
            .toString()
            .toLowerCase()
            .includes(search.toLowerCase())
      );

      if (results.length > 0) {
        if (this.recentSearchList.indexOf(this.search) === -1) {
          this.recentSearchList.push(this.search);
          localStorage.setItem(
            'automation_search',
            JSON.stringify(this.recentSearchList)
          );
        }
      }
    }
    this.cd.detectChanges();
  }

  timeout(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  get getRecentSearch(): Array<string> {
    if (this.recentSearchList != null) {
      return this.recentSearchList.filter(this.onlyUnique);
    }
    return [];
  }

  onlyUnique(value: string, index: number, self: string[]) {
    return self.indexOf(value) === index;
  }

  onKeydown(event: any) {
    this.recentSearch?.nativeElement.classList.remove('hidden');
    this.recentSearch?.nativeElement.classList.add('scalein');
  }
}